import { getMessaging, getToken } from 'firebase/messaging';

import { getFromStorage, setToStorage } from '../helpers/storage';

import { STORAGE_KEYS } from './../helpers/constants/storageKeys';
import { app } from './firebaseKeys';

const firebaseCloudMessaging = {
  // eslint-disable-next-line consistent-return
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === 'granted') {
        const swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        const fcm_token = await getToken(messaging, {
          vapidKey:
            'BHbH5qzwPuGEPH-tFUiDlgJnNKxT9L4FHeBxcR2PJctJE2LHHIRrWgzQtMd4yzNfXbVeKczY262Hwnw9g3cKg_0',
          serviceWorkerRegistration: swRegistration,
        });

        if (fcm_token) {
          setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      } else {
        console.warn('Notification permission not granted.');
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };
